<template>
  <div class="section-4">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/contact" class="footer-link">{{ $t('footer.contact') }}</router-link>
        <router-link to="/dataprivacy" class="footer-link">{{ $t('footer.dataPrivacy') }}</router-link>
        <router-link to="/termscondition" class="footer-link">{{ $t('footer.termsConditions') }}</router-link>
        <router-link to="/cookiepolicy" class="footer-link">{{ $t('footer.cookiePolicy') }}</router-link>
      </div>
      <hr class="footer-hr" />
      <img alt="footer-logo" src="../../assets/logo-white.png" class="footer-logo" />
      <p class="copyright-text">
        &copy; {{ currentYear }} ISLAW. {{ $t('footer.allRightsReserved') }}
      </p>
      
      
    </div>
  </div>
</template>

<script>

export default {
  name: 'section-4',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.section-4 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Removed fixed height for more flexibility, min-height handles content */
  min-height: 250px; /* Minimum height for a good visual presence */
  background-color: #1c1c1c; /* Dark background */
  width: 100%; /* Ensure it takes full width */
  padding: 30px 20px; /* Add internal padding for content */
  box-sizing: border-box; /* Include padding in element's total width and height */

  
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center; /* Center text content within the column */
  width: 100%;
  max-width: 1200px; /* Constrain content width on large screens */
}

.footer-links {
  display: flex;
  justify-content: center;
  /* Reduced gap for a tighter, more cohesive look */
  gap: 1.8rem;
  font-size: 1rem;
  padding-bottom: 25px; /* Reduced padding-bottom slightly */
  flex-wrap: wrap; /* Allow links to wrap on smaller screens */
}

.footer-link {
  color: rgba(255, 255, 255, 0.85); /* Slightly less bright white for softer look */
  text-decoration: none;
  font-weight: 500; /* Slightly lighter weight for modern feel */
  font-size: 1rem; /* Base font size */
  transition: color 0.3s ease, transform 0.2s ease; /* Smooth transition on hover */
  white-space: nowrap; /* Prevent links from breaking within a word */
}

.footer-link:visited {
  color: rgba(255, 255, 255, 0.7); /* Slightly different for visited, or keep same as default */
}

.footer-link:hover {
  color: #bbd55a; /* Green on hover */
  transform: translateY(-2px); /* Subtle lift effect on hover */
}

.footer-link:active {
  color: white; /* Active color */
}

.footer-hr {
  margin: 20px 0; /* Adjusted vertical margin */
  width: 70%; /* Slightly narrower horizontal rule for visual balance */
  max-width: 600px; /* Max width for the rule */
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.15); /* Softer line color */
  border-radius: 1px;
}

.footer-logo {
  padding-top: 15px; /* Adjusted padding-top */
  height: 45px; /* Slightly larger logo for better visibility */
  object-fit: contain;
  margin-bottom: 15px; /* Space below the logo */
}

.copyright-text {
  color: rgba(255, 255, 255, 0.6); /* Lighter color for copyright text */
  font-size: 0.85rem;
  margin-top: 0;
  line-height: 1.5;
}

/* --- Media Queries for Responsiveness --- */

/* Tablets and smaller desktops */
@media (max-width: 1024px) {
  .section-4 {
    min-height: 220px; /* Adjust min-height */
    padding: 25px 15px;
  }

  .footer-links {
    gap: 1.2rem; /* Smaller gap */
    font-size: 0.9rem;
    padding-bottom: 20px;
  }

  .footer-link {
    font-size: 0.95rem;
  }

  .footer-hr {
    width: 75%; /* Slightly wider on tablets */
    margin: 15px 0;
  }

  .footer-logo {
    height: 40px;
    margin-bottom: 12px;
  }

  .copyright-text {
    font-size: 0.8rem;
  }
}

/* Smaller Tablets and Mobile */
@media (max-width: 768px) {
  .section-4 {
    min-height: 200px; /* Further adjust min-height */
    padding: 20px 10px;
  }

  .footer-links {
    flex-direction: column; /* Stack links vertically for better readability */
    gap: 0.8rem; /* Smaller gap when stacked */
    font-size: 0.85rem;
    padding-bottom: 15px;
  }

  .footer-link {
    font-size: 0.9rem;
  }

  .footer-hr {
    width: 85%; /* Wider on mobile */
    margin: 10px 0;
  }

  .footer-logo {
    height: 35px;
    margin-bottom: 10px;
  }

  .copyright-text {
    font-size: 0.75rem;
  }
}

/* Very Small Mobile */
@media (max-width: 480px) {
  .section-4 {
    min-height: 180px;
    padding: 15px 10px;
  }

  .footer-links {
    gap: 0.6rem;
    font-size: 0.8rem;
    padding-bottom: 10px;
  }

  .footer-link {
    font-size: 0.85rem;
  }

  .footer-logo {
    height: 30px;
    margin-bottom: 8px;
  }

  .copyright-text {
    font-size: 0.7rem;
  }
}
</style>